module.exports = __webpack_public_path__ + "/images/ico-arrow-back.2061189.svg";